import { Stack, styled } from '@mui/material'

export const StyledTopLinks = styled(Stack)(({ theme }) => ({
  width: '100%',
  justifyContent: 'center',
  borderBottom: '1px solid',
  borderColor: theme.palette.gray.light,
  padding: theme.spacing(1, 3),
  height: '48px',
  boxSizing: 'border-box',
  'a.MuiButtonBase-root': {
    fontSize: '.7rem',
    color: theme.palette.primary.main,
   
    [theme.breakpoints.up('md')]: {
      fontSize: '.8rem',
    },
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  '.MuiDivider-root': {
    backgroundColor: theme.palette.gray.main,
    margin: theme.spacing(0, 2),
  },
  svg: {
    fill: theme.palette.tertiary.main,
    fontSize: '1.3rem !important',
  },
  '.ghost-wrapper': {
    flex: '1 0',
    display: 'flex',
    justifyContent: 'center',
  },
}))
